import { IState } from '../../store';

export const selectBuilderInfo = (state: IState) => {
  return state.offerData.company;
};
